<template>
  <ul v-if="hasItems">
    <li
      v-for="item in items"
      :key="item.value"
      class="item">
      <span :class="{label: item.label}">
        {{ item.label || item }}
      </span>
      {{ item.value }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'List',
  props: {
    items: Array
  },
  computed: {
    hasItems() {
      return this.items && this.items.length > 0
    }
  }
}
</script>

<style lang="postcss" scoped>
.item:not(:last-child) {
  margin-bottom: 5px;
}

.label {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/List.vue